function initCountdownBFCM() {
  const countdownTimerElement = document.querySelector('.eb-cart-countdown-timer');
  if (!countdownTimerElement) return;
  handleCountdown(countdownTimerElement, true);
}

function handleCountdown(el, repeatCondition = false) {
  const countdownDuration = 10 * 60;

  startCountdown(countdownDuration, el, repeatCondition);
}

let countdownInterval = null;

function startCountdown(countdownDuration, el, repeatCondition) {
  let secondsRemaining = countdownDuration;

  if (countdownInterval) {
    clearInterval(countdownInterval);
  }

  updateCountdown(secondsRemaining, el);

  countdownInterval = setInterval(function () {
    secondsRemaining--;

    updateCountdown(secondsRemaining, el);

    if (secondsRemaining <= 0) {
      const countdownCartElement = document.querySelector('.eb-cart-countdown');
      const countdownCheckoutElement = document.querySelector('.eb-checkout-countdown');

      if (repeatCondition) {
        secondsRemaining = countdownDuration;
        updateCountdown(secondsRemaining, el);
      } else {
        clearInterval(countdownInterval);

        if (countdownCartElement) {
          countdownCartElement.innerHTML =
            '<p>Forgot one final step? Place your order now and make the payment right away!</p>';
        } else {
          countdownCheckoutElement.innerHTML = '<p>Order reservation ended.</p>';
        }
      }
    }
  }, 1000);
}

function updateCountdown(seconds, el) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  el.innerHTML = `${appendZeroCharacter(minutes)}:${appendZeroCharacter(remainingSeconds)}`;
}

function appendZeroCharacter(num) {
  return num < 10 ? `0${num}` : num;
}

window.addEventListener('DOMContentLoaded', () => {
  initCountdownBFCM();
});
